import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入页脚
import mainFooter from "@/components/mainFooter.vue";
import mainHeader from "@/components/mainHeader.vue";

Vue.config.productionTip = false

// 全局引入
Vue.component('main-footer', mainFooter);
Vue.component('main-header', mainHeader);

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
